module.exports = __webpack_public_path__ + "images/248a2525407efc7be60f8be6c248daff.jpg";